'use strict';

exports.__esModule = true;
exports.typography = exports.etc = exports.colors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _colors = require('./js/_colors');

var _colors2 = _interopRequireDefault(_colors);

var _etc = require('./js/_etc');

var _etc2 = _interopRequireDefault(_etc);

var _typography = require('./js/typography');

var typography = _interopRequireWildcard(_typography);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.colors = _colors2.default;
exports.etc = _etc2.default;
exports.typography = typography;
exports.default = _extends({}, _colors2.default, _etc2.default);


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/styles/index.js
// module id = 28
// module chunks = 14